import Modal from 'react-modal'
import api, { customFuncsApi } from '../../../api'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sales } from '../../../store/slices'
import Button from '../../Button'
import { isAxiosError } from 'axios'
import _, { get } from 'lodash'
import { ClipLoader } from 'react-spinners'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { formatNumberWithIntl } from '../../../lib/FormatNumbersWithIntl'
import { useDebounce } from 'use-debounce'
import { CheckIcon } from 'lucide-react'
import SuccessModal from '../SuccessModal'
import ErrorModal from '../ErrorModal'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		maxHeight: '100vh',
		width: '85%',
	},
	overlay: {
		background: '#00000099',
	},
}

const handleBusinessPartner = _.debounce((searchFunc, value) => {
	searchFunc(value)
}, 1000)

export default function BlackListModal({ isOpen, onClose }) {
	const { getMe } = useSelector((state) => state.main)
	const role = getMe?.Department2?.Name
	const navigation = useNavigate()

	const {
		setClient: setClientStore,
		setImei: setImeiStore,
		setCardCode: setCardCodeStore,
		setPage: setPageStore,
	} = sales.actions
	const {
		client: clientStore,
		imei: imeiStore,
		cardCode: cardCodeStore,
		page: pageStore,
	} = useSelector((state) => state.sales)
	const dispatch = useDispatch()

	const errorRef = useRef()
	const succesRef = useRef()
	const [onAlertModalsOpen, setOnAlertModalsOpen] = useState(false)

	const [loadingBtn, setLoadingBtn] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [clientLoading, setClientLoading] = useState(false)
	const [client, setClient] = useState(clientStore)
	const [clientCode, setClientCode] = useState(cardCodeStore)
	const [clientsData, setClientsData] = useState([])
	const [imeiClient, setImeiClient] = useState(imeiStore)
	const [data, setData] = useState([])
	const [currentPage, setCurrentPage] = useState(pageStore)
	const [debouncedImei] = useDebounce(imeiClient, 500)
	const [openView, setOpenView] = useState(false)

	const search = useCallback(async () => {
		setIsLoading(true)

		customFuncsApi
			.get(`XsSql/getInvoices?`, {
				params: {
					$skip: currentPage,
					IntrSerial: debouncedImei || undefined,
					CardCode: client && clientCode ? clientCode : undefined,
				},
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			})
			.then((res) => {
				const resData = res.data.value || []
				setData(resData)
				setIsLoading(false)
			})
			.catch((err) => {
				if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
				setIsLoading(false)
			})
	}, [client, clientCode, currentPage, debouncedImei])

	useEffect(() => {
		search()
	}, [currentPage, search, clientCode])

	const businessPartners = async (value) => {
		setClientLoading(true)
		api
			.get(`BusinessPartners`, {
				params: {
					$select: 'CardCode, CardName, U_Telephone',
					$filter: `contains(CardName, '${value}') or contains(U_Telephone, '${value}') or contains(CardCode, '${value}') and Frozen eq 'tNO'`,
				},
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			})
			.then((res) => {
				setClientsData(JSON.parse(res.data).value || [])
				setClientLoading(false)
			})
			.catch((err) => {
				if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
				setIsLoading(false)
			})
	}

	const newDatas = () => {
		if (data.length >= 10) {
			setCurrentPage(currentPage + 10)
			dispatch(setPageStore(currentPage + 10))
		} else {
			alert('boshqa malumot yoq')
		}
	}

	const oldData = () => {
		if (data.oldPage < 0) {
			alert('boshqa malumot yoq')
		} else {
			setCurrentPage(currentPage - 10)
			dispatch(setPageStore(currentPage - 10))
		}
	}

	const viewItem = (v) => {
		if (!openView) return
		navigation('/viewItem', {
			state: {
				...v,
				from: 'black-list',
			},
		})
	}

	const switchTypeInvoice = (installmentId) => {
		if (installmentId <= 1) {
			return 'Наличные'
		} else {
			return 'Рассрочка'
		}
	}

	const handleSetBlackList = async (docEntry) => {
		setLoadingBtn(true)
		api
			.patch(`Invoices(${docEntry})`, {
				U_BlackList: 'True',
			})
			.then(() => {
				succesRef.current?.open('Задача успешно удалено')
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setLoadingBtn(false)
			})
	}

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={() => {
				setOnAlertModalsOpen(false)
				onClose()
			}}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<div className="">
				<p className="productTitle text-center font-semibold text-2xl">
					Черный список
				</p>
				<div className="flex items-end justify-betweens my-8">
					<div className="flex items-end gap-4 flex-wrap">
						<div className="flex flex-col gap-1">
							<p className="text-sm font-medium">Клиент</p>
							<div className="relative">
								<input
									className={
										'border-[1px] border-[#d9d9d9] p-2 rounded-md min-w-[250px]'
									}
									type="text"
									placeholder="Клиент"
									value={client}
									onChange={(e) => {
										setClient(e.target.value)
										handleBusinessPartner(businessPartners, e.target.value)
									}}
								/>
								{client && (
									<div className="absolute top-10 left-0 bg-white w-full z-10 border-[1px] border-[#d9d9d9] max-h-[300px] overflow-y-scroll">
										{clientsData.map((v, i) => {
											return (
												<div
													key={i}
													className="p-2 border-b cursor-pointer hover:bg-gray-100"
													onClick={() => {
														dispatch(setCardCodeStore(v.CardCode))
														dispatch(setClientStore(v.CardName))
														setClientCode(v.CardCode)
														setClient(v.CardName)
														setClientsData([])
													}}
												>
													{v.CardName}
												</div>
											)
										})}
									</div>
								)}
							</div>
						</div>
						<div className="flex flex-col gap-1">
							<p className="text-sm font-medium">IMEI</p>
							<input
								className={
									'border-[1px] border-[#d9d9d9] h-10 p-2 rounded-md w-[150px]'
								}
								type="text"
								placeholder="Имеи"
								defaultValue={imeiClient}
								onChange={(v) => {
									setImeiClient(v.target.value)
									dispatch(setImeiStore(v.target.value))
								}}
							/>
						</div>
					</div>
				</div>

				{isLoading ? (
					<div className="w-full flex items-center justify-center my-10 mx-auto">
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					</div>
				) : (
					<>
						<div className="overflow-y-auto mb-8">
							<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
								<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
									<tr>
										<th scope="col" className="px-6 py-4">
											Дата продажи
										</th>
										<th scope="col" className="px-6 py-4">
											Имя Клиента
										</th>
										<th scope="col" className="px-6 py-4">
											Товар
										</th>
										<th scope="col" className="px-6 py-4">
											Имеи
										</th>
										<th scope="col" className="px-6 py-4">
											Условия продажи
										</th>

										{role !== 'Undiruvchi1' && (
											<th scope="col" className="px-6 py-4">
												Сумма
											</th>
										)}
										<th scope="col" className="px-6 py-4">
											Филиал
										</th>
										<th
											scope="col"
											className="px-6 py-4"
											onFocus={() => setOpenView(true)}
											onBlur={() => setOpenView(false)}
										>
											&nbsp;
										</th>
									</tr>
								</thead>
								<tbody>
									{data.map((v, i) => {
										return (
											<tr
												key={i}
												onClick={() => {
													// if (role === 'Undiruvchi1') return
													viewItem(v)
												}}
												className="bg-white border-b  hover:bg-gray-50 "
											>
												<td className="px-6 py-4">
													{moment(get(v, 'DocDate', '-')).format('DD-MM-YYYY')}
												</td>
												<td className="px-6 py-4">{get(v, 'CardName', '-')}</td>
												<td className="px-6 py-4">
													{get(v, 'Dscription', '-')}
												</td>
												<td className="px-6 py-4">
													{get(v, 'IntrSerial', '-')}
												</td>
												<td className="px-6 py-4">
													{switchTypeInvoice(get(v, 'Installmnt', '-'))}
												</td>

												{role !== 'Undiruvchi1' && (
													<td className="px-6 py-4">
														{formatNumberWithIntl(get(v, 'DocTotal', '-'))}
													</td>
												)}
												<td className="px-6 py-4">{get(v, 'WhsCode', '-')}</td>
												<td className="px-6 py-4">
													<Button
														className="btn"
														size="sm"
														onClick={() => handleSetBlackList(v.DocEntry)}
														disabled={loadingBtn}
													>
														<CheckIcon />
													</Button>
												</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
						<div className="topCard">
							<div className="flex items-center gap-2 ">
								<Button
									disabled={currentPage === 0}
									className={'btn'}
									onClick={oldData}
								>
									{'<'}
								</Button>
								<p>{currentPage / 10 + 1}</p>
								<Button
									disabled={data.length < 10}
									className={'btn'}
									onClick={newDatas}
								>
									{'>'}
								</Button>
							</div>
						</div>
					</>
				)}
			</div>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
				onConfirm={() => {
					setOnAlertModalsOpen(false)
				}}
			/>
			<SuccessModal
				getRef={(r) => {
					succesRef.current = r
				}}
				onConfirm={() => {
					onClose()
					setOnAlertModalsOpen(false)
				}}
			/>
		</Modal>
	)
}
